import store from "@/store";

const state = {
  updatedOrgStructureId: null,
};

const mutations = {
  setUpdatedOrgStructureId(state, payload) {
    state.updatedOrgStructureId = payload;
  },
};

const actions = {
  setUpdatedOrgStructureId({ commit }, payload) {
    commit("setUpdatedOrgStructureId", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
